module.exports = __webpack_public_path__ + "img/news1-1.48b430a5.png";